import { TOP_GAME_PERIODS } from 'components/config/analytics';

export const appendTopGamesPercentage = (games) => {
  const step = 2;
  let counter = 100;

  return games?.map((game, index) => ({
    ...game,
    percentage: !index ? counter : (counter -= step),
  }));
};

export const appendTopGameColors = (games, colors) =>
  games?.map((game, index) => ({
    ...game,
    backgroundColor: colors[index],
  }));

export const getPeriodValuesFromStr = (periodStr) => {
  const now = new Date();

  let monthsBack;
  let fromDate;
  let toDate = new Date(now.getFullYear(), now.getMonth(), 1);

  switch (periodStr) {
    case TOP_GAME_PERIODS.lastMonth:
      monthsBack = 1;
      break;
    case TOP_GAME_PERIODS.last3Months:
      monthsBack = 3;
      break;
    case TOP_GAME_PERIODS.last6Months:
      monthsBack = 6;
      break;
    case TOP_GAME_PERIODS.lastYear:
      monthsBack = 12;
      break;
  }

  fromDate = new Date(toDate);
  fromDate.setMonth(fromDate.getMonth() - monthsBack);

  const format = (date) =>
    `${date.getFullYear()}-${`${date.getMonth() + 1}`.padStart(2, '0')}`;

  return {
    fromMonth: format(fromDate),
    toMonth: format(new Date(toDate.setMonth(toDate.getMonth() - 1))),
  };
};
